import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const UserSquare = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M18.1404 21.62C17.2604 21.88 16.2204 22 15.0004 22H9.00035C7.78035 22 6.74035 21.88 5.86035 21.62M18.1404 21.62C17.9204 19.02 15.2504 16.97 12.0004 16.97C8.75035 16.97 6.08035 19.02 5.86035 21.62M18.1404 21.62C20.8604 20.85 22 18.78 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 18.78 3.14035 20.85 5.86035 21.62M12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.60002 10.02 7 12 7C13.98 7 15.58 8.60002 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
